import gql from 'graphql-tag';

export const EMPLOYEE_LIST_FILTER = gql`
query employeeListFilterReadiness {
  allEmpoloyee: me {
    id
    employee {
      id
      orgCeoEmployee {
        edges {
          node {
            id
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      orgPocEmployee {
        edges {
          node {
            id
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      teamManagerEmployee {
        edges {
          node {
            id
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      verticalHeadEmployee {
        edges {
          node {
            id
            employees(user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`